module.exports = __webpack_public_path__ + "/bundle/asset/official_line-56c20867369c3c56423ee001f69b170f.png";